import { RefObject } from 'react';
import { IntlShape } from 'react-intl';
import { toast } from 'react-toastify';
import byteSize from 'byte-size';

import { EXPERTISES } from 'containers/common/LegalProceedings/JudgementAdd/Forms/JudgementAddPrononcings/constants';

import * as utils from 'containers/IdentificationPage/SearchResults/ClaimWithNotIndexedPV/utils';
import { translate } from 'containers/services/translate';
import { FILE_LIMIT, FILE_TYPE } from 'containers/UploadDocuments/constants';
import messages from 'containers/UploadDocuments/messages';
import { expertType } from 'containers/common/LegalProceedings/JudgementAdd/Forms/JudgementAddPrononcings/typings';
import {
  VEHICULE_EXPERTISE_FIELDS,
  VICTIM_EXPERTISE_FIELDS,
} from 'containers/data-structure';

export const isChecked = (id: number, dataSet: Set<number>) => dataSet.has(id);
export const isCheckedVictimExpertise = (id: number, expertises: any) => {
  return Array.from(expertises).some(
    (item: any) => Number(item.victimId) === Number(id) && !item.isDeleted,
  );
};
export const isCheckedVehicleExpertise = (id: number, expertises: any) => {
  return Array.from(expertises).some(
    (item: any) => item.vehiculeId === id && !item.isDeleted,
  );
};
export const shouldDisplayVictims = (expertise: string): boolean =>
  expertise === EXPERTISES.MEDICAL || expertise === EXPERTISES.ACCOUNTING;

export const shouldDisplayVehicules = (expertise: string): boolean =>
  expertise === EXPERTISES.MECHANICAL || expertise === EXPERTISES.ACCOUNTING;

export const uploadClick = (fileRef: RefObject<HTMLInputElement>) => () => {
  fileRef.current?.click();
};

export const fileSelectHandler = (
  uploadDocument: Function,
  props: { intl: IntlShape },
) => (event: any) => {
  const [file] = event.target.files || event.dataTransfer.files;

  if (file.size < FILE_LIMIT && file.type === FILE_TYPE) {
    uploadDocument(file);
  } else {
    const { value, unit } = byteSize(FILE_LIMIT);
    toast.error(
      translate(messages.errorUploadDocumentSizeAndType, props, {
        size: `${~~value}${unit}`,
      }),
    );
  }
  const list = utils.emptyFile();
  event.target.files = list.files;
};

export const getExpertiseInfo = (
  itemId: number | null,
  label: string,
  expertises: Set<expertType>,
) => {
  for (let item of expertises) {
    if (String(item[label]) === String(itemId)) return item;
  }
  return {};
};

export const extractFieldValue = (
  itemId: number,
  label: string,
  name: string,
  expertiseSetInfo: Set<expertType>,
) => {
  let expertiseInfo = getExpertiseInfo(
    itemId,
    label,
    expertiseSetInfo,
  ) as expertType;

  return expertiseInfo[name];
};

export const resolveLabel = (victimId: number | null) => {
  if (victimId) {
    return VICTIM_EXPERTISE_FIELDS.VICTIM_ID;
  } else {
    return VEHICULE_EXPERTISE_FIELDS.VEHICULE_ID;
  }
};
